import { useState, useEffect } from "react";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL || "http://localhost:3001";

// Fetch average ratings for many products in ONE request (/api/reviews/avg-batch),
// returning a { [productId]: { avg, count } } map. Powers the small ★ badge under
// product images on grids. Re-fetches when the set of ids changes (order-insensitive).
export function useAvgRatings(ids) {
  const [map, setMap] = useState({});
  const key = Array.isArray(ids) ? [...new Set(ids.filter(Boolean))].sort().join(",") : "";
  useEffect(() => {
    if (!key) { setMap({}); return; }
    let cancelled = false;
    const idList = key.split(",").slice(0, 200);
    fetch(`${BACKEND_URL}/api/reviews/avg-batch?ids=${encodeURIComponent(idList.join(","))}`)
      .then(r => (r.ok ? r.json() : {}))
      .then(d => { if (!cancelled) setMap(d && typeof d === "object" ? d : {}); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [key]);
  return map;
}
